import { apiRoutes, Hiver_Base_Url } from "../Constant/ApiRoutes";
import axios from "axios";
import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "../apiRequest";

// Axios instance for PHP/Laravel backend (Hiver main backend)
const hiverAxios = axios.create({
  withCredentials: true,
  baseURL: Hiver_Base_Url,
});

// Helper to get the current KB ID for scoping API calls in multi-KB mode
const getKbParams = () => {
  const kbId = window.__kbId;
  return kbId ? { knowledgeBaseId: kbId } : undefined;
};

//Get MailBox Contact Details
export const getMailBoxDetails = () => {
  return getRequest(apiRoutes.kbSharedMainBox, getKbParams());
};

//Get KB Info
export const getKbInfo = () => {
  return getRequest(apiRoutes.kbSettingsData, getKbParams());
};

//List all Knowledge Bases for the current user (via PHP backend /api/kbs)
export const listKnowledgeBases = () => {
  return hiverAxios.get('api/kbs');
};

// Get the user's server-persisted default KB ID
export const getDefaultKbApi = () => {
  return hiverAxios.get('api/kb-default');
};

// Save the user's default KB ID on the server
export const setDefaultKbApi = (knowledgeBaseId) => {
  return hiverAxios.put('api/kb-default', { knowledgeBaseId });
};

// Get a one-time gateway auth code for cross-domain SSO (60s TTL)
export const getGatewayAuthCode = () => {
  return hiverAxios.get('api/auth/login/code');
};

//to fetch all available features
export const getAvailableFeatures = () => {
  return getRequest(apiRoutes.availableFeatures);
};

export const getLoggedInUserDetails = () => {
  return getRequest(apiRoutes.getUserDetails);
}

//Branding
export const postSiteBranding = (payload) => {
  return postRequest(apiRoutes.kbBranding, payload, getKbParams());
};

export const putSiteBranding = (payload) => {
  return putRequest(apiRoutes.kbBranding, payload, getKbParams());
};

// SiteSettings
export const putSiteSetting = (payload) => {
  return putRequest(apiRoutes.kbSiteSetting, payload, getKbParams());
};

//// Domain Check
export const domainCheck = (payload) => {
  return getRequest(apiRoutes.kbcheckSubdomain, { keyword: payload, ...getKbParams() });
};

//// Code Snippets
export const postSnippets = (payload) => {
  return postRequest(apiRoutes.kbSnippets, payload, getKbParams());
};

export const putSnippets = (payload) => {
  return putRequest(apiRoutes.kbSnippets, payload, getKbParams());
};

export const deleteSnippets = (payload) => {
  return deleteRequest(apiRoutes.kbSnippets, payload, getKbParams());
};
